import "../../styles/RoundLogItem.css"
import appIcon from "../../images/app_icon.jpg"

export const PerPlayerRoundLogItem = ({ company, message, size }) => {
    return (
        <div>
            <div style={{ margin: "14px" }}>
                <div className={`round-log-item-container-${size}`}>
                    {company && <img className={`round-log-item-image-${size}`} src={`${process.env.REACT_APP_SERVER_URL}/image/${company}.png`} alt=""></img>}
                    {!company && <img className={`round-log-item-image-${size}`} src={appIcon} alt=""></img>}
                    {<p className={`round-log-item-message-${size}`}>{message}</p>}
                </div>
            </div>
        </div>
    )
}